#!/usr/bin/env node
/**
 * 创建MCP项目CLI工具入口
 * - 自动生成MCP项目基础结构
 * - 支持自定义项目配置
 */

import { Command } from 'commander';
import inquirer from 'inquirer';
import chalk from 'chalk';
import { createProject } from './templates/create-project.js';
import { CliOptions } from './utils/types.js';
import { validateProjectName } from './utils/validation.js';
import { showBanner } from './utils/banner.js';

// 显示欢迎信息
showBanner();

const program = new Command();

program
  .name('create-mcp')
  .description('创建基于MCP协议的项目脚手架')
  .version('1.0.0', '-v, --version', '显示版本号')
  .argument('[project-name]', '项目名称')
  .option('-t, --type <type>', '项目类型 (oss|custom)', 'custom')
  .option('-d, --dir <directory>', '创建项目的目录', './')
  .option('-f, --force', '强制创建项目，覆盖已存在的目录', false)
  .option('--skip-install', '跳过依赖安装', false)
  .action(async (projectName: string | undefined, options: any) => {
    let name = projectName;
    let type = options.type as string;

    // 如果命令行中没有提供项目名称，通过交互式提示获取
    if (!name) {
      const answers = await inquirer.prompt([
        {
          type: 'input',
          name: 'projectName',
          message: '请输入项目名称:',
          validate: validateProjectName,
        }
      ]);
      name = answers.projectName;
    }

    // 如果类型不是预设选项，询问用户选择项目类型
    if (!['oss', 'custom'].includes(type)) {
      const answers = await inquirer.prompt([
        {
          type: 'list',
          name: 'projectType',
          message: '请选择项目类型:',
          choices: [
            { name: 'OSS上传服务 (阿里云对象存储)', value: 'oss' },
            { name: '自定义MCP服务', value: 'custom' }
          ],
          default: 'custom',
        }
      ]);
      type = answers.projectType;
    }

    // 收集额外配置
    const answers = await inquirer.prompt([
      {
        type: 'confirm',
        name: 'includeExamples',
        message: '是否包含示例配置和说明?',
        default: true,
      },
      {
        type: 'input',
        name: 'author',
        message: '作者名称:',
        default: '',
      },
      {
        type: 'input',
        name: 'description',
        message: '项目描述:',
        default: type === 'oss' ? '基于MCP协议的阿里云OSS上传服务' : '基于MCP协议的自定义服务',
      }
    ]);

    const cliOptions: CliOptions = {
      projectName: name!,
      projectType: type,
      targetDirectory: options.dir,
      includeExamples: answers.includeExamples,
      skipInstall: options.skipInstall,
      force: options.force,
      author: answers.author,
      description: answers.description
    };

    console.log(chalk.blue('✨ 开始创建项目...'));
    await createProject(cliOptions);
  });

program.parse(process.argv);
